import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, input, type InputSignal } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { MenuItem } from 'primeng/api';
import { UBaseInfraComponent } from '../u-base-infra.component';

@Component({
  selector: 'u-menubar',
  templateUrl: './u-menubar.component.html',
  styleUrls: ['./u-menubar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UMenubarComponent extends UBaseInfraComponent {
  items: InputSignal<MenuItem[]> = input<MenuItem[]>();
  styles: InputSignal<any> = input<any>();

  @Output() itemClick = new EventEmitter<MenuItem>();

  onItemClick(event: Event, item: MenuItem) {
    this.itemClick.emit(item);

    if (item.command) {
      item.command({ originalEvent: event, item });
    }
  }
  getIconRef() {
    return null;
  }
}
